import React from "react";
import messages from './messages';
import { injectIntl } from 'react-intl';

class SuggestionsStory extends React.Component {
  constructor(props) {
    super(props);
    this.suggestionsContainer = React.createRef();
  }

  componentDidMount() {
    Notifications.setupSuggestions(this.suggestionsContainer.current, this.props.type);
  }

  render() {
    const type = this.props.type === 'product_category' ? 'category' : this.props.type;
    const title = this.props.intl.formatMessage(
      messages['generalStoryTitle'], {
        type: this.props.intl.formatMessage(messages[`${type}Pluralization`]),
      });
    return (
      <div className="afd-story myarchdaily-recommendations-wrapper" data-insights-category="myad-feed" data-insights-label="suggestion-story" data-insights-value={this.props.type} >
        <h2 className="afd-title-big afd-title-big--bmargin-big">
          {title}
        </h2>
        <div ref={this.suggestionsContainer} className={`afd-suggestions afd-suggestions-${type}`}/>
      </div>
    )
  }
}

export default injectIntl(SuggestionsStory);